import React, { useState, useContext, useEffect } from 'react';
import Card from '../UI/card/Card';
import styles from './ReservationTable.module.css';
import SortTable from '../UI/sortTable/SortTable';
import { IApiParametersValues, IreservationDetails } from '../../interfaces';
import ReservationContext from '../../context/ReservationContext';
import { paginationConstants } from '../../utils/contants';
import SimpleBuiPagination from '../UI/simpleBuiPagination/SimpleBuiPagination';
import { reservationListSliceHandler } from '../../utils/utils';
interface IReservationTable {
  reservationDetails: {
    totalNumberOfResults: number;
    response: Array<IreservationDetails>;
  };
  getReservationTableDetailsHandler: (values: IApiParametersValues) => void;
}

const ReservationTable = ({
  reservationDetails,
  getReservationTableDetailsHandler
}: IReservationTable) => {
  const reservationCtx = useContext(ReservationContext);
  const [currentPage, setCurrentPage] = useState(+paginationConstants.pageNumber);
  const [pageSize, setPageSize] = useState(+paginationConstants.pageLimit);

  useEffect(() => {
    setCurrentPage(+reservationCtx.pageNumber);
    setPageSize(+reservationCtx.pageLimit);
  }, [reservationDetails]);

  const sortReservationTableHandler = (key: string, order: string) => {
    reservationCtx.pageNumber = currentPage.toString();
    reservationCtx.sortField = key;
    reservationCtx.sortOrder = order;
    reservationCtx.pageLimit = pageSize.toString();
    getReservationTableDetailsHandler(reservationCtx);
  };

  return (
    <Card className={styles.reservationTableContainer}>
      <h3>{`Found ${reservationDetails.totalNumberOfResults} matching reservations`}</h3>
      <p>Click on a column heading to change the sort order.</p>
      <SortTable
        reservationDetails={reservationListSliceHandler(currentPage, pageSize, reservationDetails)}
        sortReservationTableHandler={sortReservationTableHandler}
      />
      {reservationDetails.totalNumberOfResults > pageSize && (
        <SimpleBuiPagination
          currentPage={currentPage}
          onPageChange={(page) => {
            setCurrentPage(Number(page));
            reservationCtx.pageNumber = page as string;
          }}
          pageSize={pageSize}
          totalCount={reservationDetails.totalNumberOfResults}
        />
      )}
    </Card>
  );
};
export default ReservationTable;
